import { TaskCenterTypes } from '@frontend/api-task-center';

export const BASE_QUERY_KEY = 'task-center';

export const getTaskCenterQueryKeys = (status: TaskCenterTypes.TaskStatus) => [
  BASE_QUERY_KEY,
  TaskCenterTypes.TaskStatus[status],
];
